import { AnyAction } from 'redux';
import { AddVertragToAngebote, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, getAnzahlVorschaeden, VwgVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { TaasTarifrisikoschluesselTHH } from '@ps20/bff-models';
import { ThhHundActions } from '../thhHundActions';

export interface Vorschaeden {
  vorhanden: boolean | null;
  thhHundVorschaeden: number;
}

export const vorschaedenReducer = function (
  sectionState: Vorschaeden = null,
  action: AnyAction,
): Vorschaeden {
  switch (action.type) {
    case ThhHundActions.VORSCHAEDEN_VORHANDEN: {
      return {
        ...sectionState,
        thhHundVorschaeden: 0,
        vorhanden: action.payload,
      };
    }
    case ThhHundActions.VORSCHADEN_VALUE_CHANGED: {
      const { vorschadenId, value } = action.payload;
      return { ...sectionState, [vorschadenId]: value };
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (actionPayload.appId === App.THH_HUND && action.payload.vorvertragsNummern) {
        return {
          ...sectionState,
          thhHundVorschaeden: 0,
          vorhanden: false,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_HUND) {
        const anzVorschaedenHund = getAnzahlVorschaeden(
          actionPayload.vorvertragBausteinList,
          TaasTarifrisikoschluesselTHH.H,
        );
        return {
          ...sectionState,
          vorhanden: anzVorschaedenHund > 0,
          thhHundVorschaeden: anzVorschaedenHund,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
